export default "__VITE_ASSET__mtK0esKI__ 800w, __VITE_ASSET__kdIUvwyK__ 600w, __VITE_ASSET__LwljBFV$__ 400w";